import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { validateReplicasApiKey, validateReplicasEnvironmentId } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Claude Code via Replicas",
  category: AgentCategory.CODING,
  displayNameOverride: "Claude Code",
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#d97757",
  description: "Build, test, and fix code within your GitHub repo, launched directly from your Dart tasks",
  descriptionMarkdown: `## Overview

Delegate coding work to Claude Code, Anthropic's AI coding agent. Dart starts a run from your task and completes it when Claude Code opens a pull request. Powered by [Replicas](https://replicas.dev).

## Setup guide

1. Create an account at [replicas.dev](https://replicas.dev) and connect your GitHub repository under [Repository Configuration](https://www.replicas.dev/dashboard?section=platform-github)
2. Configure your Claude credentials in the Replicas dashboard under [Agents](https://replicas.dev/dashboard?section=platform-agents)
3. Upgrade to the Replicas Dev plan and generate an API key from [Platform > API Keys](https://www.replicas.dev/dashboard?section=platform-apikeys)
4. Open [Environments](https://www.replicas.dev/dashboard?section=platform-environment), select your environment, and copy its ID
5. Paste your Replicas API key and environment ID below
6. Assign coding tasks to the Claude Code agent in Dart`,

  configFields: [
    {
      key: "apiKey",
      type: "password",
      label: "Replicas API key",
      placeholder: "Your Replicas API key",
      validate: validateReplicasApiKey,
    },
    {
      key: "environmentId",
      type: "text",
      label: "Replicas environment ID",
      placeholder: "Your Replicas environment ID",
      validate: validateReplicasEnvironmentId,
    },
  ],
};

export default config;
